import { Box } from '@chakra-ui/react';
import { Popover, Text, useToast } from '@melio/penny';
import { useAccount } from '@melio/platform-api';
import { useMelioIntl } from '@melio/platform-i18n';

type Props = {
  onCopy?: (value: string) => void;
};

export const InboxEmailAddressCopyLinkWidget = ({ onCopy }: Props) => {
  const toast = useToast();
  const { formatMessage } = useMelioIntl();

  const { data } = useAccount({ id: 'me' });

  const handleCopyToClipboard = (value: string) => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        toast({ type: 'info', title: formatMessage('widgets.inboxEmailAddressCopyLink.toast.success') });
        onCopy?.(value);
      })
      .catch(() => toast({ type: 'error', title: formatMessage('widgets.inboxEmailAddressCopyLink.toast.error') }));
  };

  const inboxEmailAddress = data?.company.inboxEmailAddress;
  return inboxEmailAddress ? (
    <Text textStyle="body4" color="neutral.darker" data-testid="inbox-email-address-copy-link-label">
      {formatMessage('widgets.inboxEmailAddressCopyLink.label', {
        link: (
          <Popover
            description={formatMessage('widgets.inboxEmailAddressCopyLink.description', { email: inboxEmailAddress })}
            actionProps={{
              label: formatMessage('widgets.inboxEmailAddressCopyLink.cta'),
              onClick: () => handleCopyToClipboard(inboxEmailAddress),
            }}
            placement="top-end"
            data-testid="inbox-email-address-copy-link-popover"
          >
            <Box
              as="span"
              color="neutral.black"
              textDecoration="underline"
              cursor="pointer"
              data-testid="inbox-email-address-copy-link-link"
              _hover={{
                color: 'brand.main',
              }}
            >
              {formatMessage('widgets.inboxEmailAddressCopyLink.link')}
            </Box>
          </Popover>
        ),
      })}
    </Text>
  ) : null;
};

InboxEmailAddressCopyLinkWidget.displayName = 'InboxEmailAddressCopyLinkWidget';
